import React from 'react';
import { getImageUrl } from '../lib/imageUtils';

const Gallery = ({ images = [] }) => {
  const visibleImages = images.filter(img => img.image_url && img.image_url.trim());

  if (visibleImages.length === 0) return null;

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-3">Our Workspace</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Visit Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800">Premises</span>
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-500 to-yellow-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {visibleImages.map((img, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300"
              data-testid={`gallery-image-${index}`}
            >
              <img
                src={getImageUrl(img.image_url)}
                alt={img.title}
                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 via-blue-900/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <h4 className="text-white text-xl font-bold mb-1">{img.title}</h4>
                {img.caption && <p className="text-white/90 text-sm">{img.caption}</p>}
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 group-hover:opacity-0 transition-opacity">
                <h4 className="text-white text-lg font-bold">{img.title}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
